import Vue from "vue";
import { REGISTER_TENANT_ID } from "@/store/mutation-types";

/**
 * 获取实际注册的userName
 * （给每个账号加上tenantId标识）
 */
export function getUserName(userName, type = "注册") {
  return userName.toUpperCase() === "ADMIN" && type === "登陆"
    ? userName
    : `${userName}_${Vue.ls.get(REGISTER_TENANT_ID)}`;
}

/**
 * 获取userName渲染
 */
// 处理userName渲染
export function handleUserNameRender(userName, bTenantId) {
  const endStr = `_${bTenantId}`;
  return userName.endsWith(endStr)
    ? userName.slice(0, -endStr.length)
    : userName;
}
